// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jrUkq","type":"styles_type__3u6Ta","choices":"styles_choices__3gDnt"};